/*
 * Bliss Out Coffee: keep the chosen purchase option when the size changes.
 *
 * Problem: the Shopify Subscriptions block keeps a separate radio group per
 * variant (227g, 454g). Each group starts on "One-time purchase", so changing
 * the size silently drops the subscription.
 *
 * Fix: right before the size changes, remember which option is selected
 * (for example "Deliver every month" or "One-time purchase"), then select the
 * same option in the group of the new size.
 *
 * If the page markup is not found, this script does nothing.
 */
(function () {
  if (window.__blissKeepPlan) return;
  window.__blissKeepPlan = true;

  var BLOCK = '.shopify_subscriptions_app_container input[type=radio]';

  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  // "Deliver every 2 months, 10% off\n$20.70 CAD" -> "Deliver every 2 months"
  function labelOf(radio) {
    var label = radio.closest('label');
    var text = label ? label.innerText : '';
    return (text.split('\n')[0] || '').split(',')[0].trim();
  }

  function visibleRadios() {
    return Array.prototype.slice.call(document.querySelectorAll(BLOCK)).filter(isVisible);
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest('[data-swatch-item]')) return;

      var current = visibleRadios().find(function (r) { return r.checked; });
      if (!current) return;
      var wanted = labelOf(current);
      if (!wanted) return;

      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        var match = visibleRadios().find(function (r) { return labelOf(r) === wanted; });
        if (match) {
          if (!match.checked) match.click();
          clearInterval(timer);
        } else if (tries > 30) {
          clearInterval(timer);
        }
      }, 100);
    },
    true
  );
})();
